import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import API from '../../../create/api';
import { useParams } from 'react-router-dom';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@mui/system/Box';
import Button from '@mui/material/Button';
import { getLabel, getParcelPrice } from './map';
import { useStore } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700,
    '& .MuiTableCell-root': {
      border: '1px solid #c7c7c7',
    },
  },
  tableBorder: {
    '& .MuiTableCell-root': {
      border: '1px solid #c7c7c7',
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  fromControl: {
    width: '100%',
  },
  createButton: {
    paddingBottom: theme.spacing(2),
  },
  centerAlign: {
    textAlign: 'center',
    'span &': {
      verticalAlign: 'middle',
    },
  },
  tdBorder: { border: '1px solid black ', fontSize: '20px', padding: '0 5px' },
  onlyPrint: { display: 'none' },
  hidePrint: {},
  '@media print': {
    'table tr': {
      pageBreakBefore: 'always',
    },
    hidePrint: {
      display: 'none',
    },
    onlyPrint: { display: 'block' },
    printStyle: {
      border: '1px solid  black',
      fontSize: '20px',
      padding: '0 5px',
    },
    numberSize: { fontSize: '30px' },
  },
}));

export default function CreatePayment() {
  const store = useStore();
  const classes = useStyles();
  const { id }: any = useParams();
  const queryParams = new URLSearchParams(window.location.search);
  const focusID = queryParams.get('focusID');

  const [company, setCompany] = React.useState({} as any);
  interface Parcel {
    merchant_COD: number;
    COD: number;
    deliveryCharge: number;
    id: string;
    amount: number;
    company: any;
  }
  const [getParcels, setParcels] = React.useState([] as Parcel[]);

  useEffect(() => {
    API.get(`${process.env.REACT_APP_API_SERVER}/payments`, id)
      .then((payment: any) => {
        setParcels(payment.parcels);
        setCompany(payment.company);
      })
      .finally(() => {
        scrollToHash();
      });
  }, [id]);

  const handlePrint = () => {
    store.dispatch({ type: 'CLOSE_SIDEBAR' });
    setTimeout(() => {
      window.print();
    }, 100);
  };

  function scrollToHash() {
    if (window.location.hash) {
      const hash = window.location.hash;
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }

  return (
    <Grid container>
      <Grid item xs={12} className={clsx(classes.createButton, classes.hidePrint)}>
        {company?.name}
        <Button
          size="small"
          variant="contained"
          sx={{ marginTop: '10px', marginLeft: '20px' }}
          color="primary"
          onClick={handlePrint}
        >
          Print
        </Button>
      </Grid>
      <Grid xs={12} className={clsx(classes.onlyPrint, classes.createButton)}>
        <Grid item xs={12} className={classes.createButton}>
          <h1 style={{ textAlign: 'center' }}>Invoice</h1>
          <hr style={{ borderTop: '5px solid black' }} />
        </Grid>
        <Grid container>
          <Grid xs={6}>
            <div style={{ marginLeft: '15%' }}>
              <h6 style={{ textDecoration: 'underline' }}> Invoice from:</h6>
              <h1> {process.env.REACT_APP_COURIER_COMPANY_NAME} </h1>
              <div>
                <h5
                  dangerouslySetInnerHTML={{
                    __html: String(process.env.REACT_APP_COURIER_COMPANY_ADDRESS?.replaceAll('\n', '<br/>')),
                  }}
                ></h5>
              </div>
            </div>
          </Grid>
          <Grid xs={6}>
            <div
              style={{
                paddingLeft: '15%',
                borderLeft: '2px solid black',
              }}
            >
              <h6 style={{ textDecoration: 'underline' }}> Invoice to:</h6>
              <h1> {company?.name} </h1>
              <h5>ID: {company?.id}</h5>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.createButton}>
            <hr style={{ borderTop: '5px solid black' }} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} className={classes.createButton} style={{ marginTop: '10px' }}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead style={{ backgroundColor: 'lightgray' }}>
              <TableRow>
                <TableCell>
                  <b>Booking</b>
                </TableCell>
                <TableCell>
                  <b>APN</b>
                </TableCell>
                <TableCell align="right">
                  <b>Invoice</b>
                </TableCell>
                <TableCell align="left">
                  <b>Customer</b>
                </TableCell>
                <TableCell align="right">
                  <b></b>
                </TableCell>
                <TableCell align="right">
                  <b>COD</b>
                </TableCell>
                <TableCell align="right">
                  <b>Collected</b>
                </TableCell>
                <TableCell align="right">
                  <b>DC</b>
                </TableCell>
                <TableCell align="right">
                  <b>Amount</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getParcels?.map((row: any) => (
                <TableRow
                  key={row.id}
                  className={focusID && parseInt(focusID) === row.id ? `bg-gray-300` : ''}
                  id={`parcel-${row.id}`}
                >
                  <TableCell component="th" scope="row">
                    {row?.booking_date}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.id}
                  </TableCell>
                  <TableCell align="right">{row?.memoNo}</TableCell>
                  <TableCell align="left">{row?.customerName}</TableCell>
                  <TableCell align="left">{getLabel(row?.status)}</TableCell>
                  <TableCell align="right">{row?.merchant_COD}</TableCell>
                  <TableCell align="right">{getParcelPrice(row)}</TableCell>
                  <TableCell align="right">{row?.deliveryCharge}</TableCell>
                  <TableCell align="right">{row?.amount}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid
          container
          className="bg-white border border-[#c7c7c7]"
          justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
        >
          <Grid item xs={12} md={4}>
            <Box className="w-full mt-2">
              <Table className={classes.tableBorder}>
                <TableRow>
                  <TableCell>Subtotal Parcel</TableCell>
                  <TableCell align="right">
                    {getParcels.reduce((acc, parcel) => acc + parcel.deliveryCharge + parcel.amount, 0)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Delivery Charge</TableCell>
                  <TableCell align="right">
                    {getParcels.reduce((acc, parcel) => acc + parcel.deliveryCharge, 0)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Total Payment</TableCell>
                  <TableCell align="right">{getParcels.reduce((acc, parcel) => acc + parcel.amount, 0)}</TableCell>
                </TableRow>
              </Table>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
